import React,{ Component } from 'react';
import $ from 'jquery';
import {Link} from 'react-router';
import WebHeaderInner from './WebHeaderInner.js';
import WebFooter from './WebFooter.js';
// import ReactCountdownClock from 'react-countdown-clock';

export default class Web_AllPromoOffers extends Component {
	constructor(props){
		super(props);
		this.state={
			loading: false,
			nodata: false,
			offers:[],
			seed_offers:[],
			product_offers: [],
			deals:[],
		};
		this.getOffers=this.getOffers.bind(this);
	}

	getOffers()
	{
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'desktop_web',lat:'',long:'',device_id:localStorage.getItem('push_device_id')}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			url:baseUrl+'viewPromotedDeals',
			data:{req:data2},
			dataType:'json',
			success: function(data)
			{
				if(data.deals.length === 0)
				{
        			this.setState({
        				nodata: true,
        				loading:true,
        			});
        		}
        		else
        		{
        			this.setState({
        				nodata: false,
        				loading:true,
        				deals: data.deals,
        			});
        		}
			}.bind(this),
			error: function(err)
			{
				console.log(err);
			}
		});
	}
	componentDidMount()
	{
		if(screen.width < 800)
	  	{
	    	window.location.href="/promotional_offers";
	  	}
		this.getOffers();
	}
	render(){
		document.title="Promotional Deals | AquaDeals";
		var deals = this.state.deals.map((deal, index) => (<Deal key={index} data={deal} />))
		return(
		 <div>	
			<div className="web_deals web_promo_deals_page">
			{this.state.loading ? <div className="lgt_gry">
				<WebHeaderInner />
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="pag_cntnt">&nbsp;</div>
				  <section className="container dels_cntnt">
						<div className="row">
							<div className="col-md-3 col-lg-3">
								<div className="row del_lft">
									<h5 className="fltr_title">Promotional Offers</h5>
								</div>
							</div>
							<div className="col-md-9 del_rgt">
								<div className="del_rgt_blk">
									<div className="col-md-12"></div>
									<div className="clr"></div>
									<div className="row itm_lst">
										{this.state.nodata ? 
											<div className="webno_data">
												<h3>No Deals Available</h3>
												<p>Need something here? <Link to={"/web/customer_care"}>CONTACT US</Link> now !</p>
											</div> :  deals.length > 0 ? <div className="">{deals}</div> :  <div className="no_data">
										<h3>No Deals Available</h3>
										<p>Need something here? <Link to="/web/customer_care">CONTACT US</Link> now !</p>
										</div> }
									</div>
								</div>
							</div>
							<div className="clr">&nbsp;</div>
						</div>
					</section>
					<div className="clr"></div>
               		 
					</div> : <div className="loading_sym"><img src={'https://aquadeals.in/admin/assets/images/web_imgs/loading.gif'} alt="Loading" role="presentation" /> </div> }
		   
		</div>	
		<WebFooter />
	</div>	
		);
	}
}

export class Deal extends Component {
    constructor(props){
    	super(props);
    	this.state={
    		data1: this.props.data,
    		time: this.props.data.micro_time,
    		seconds: Math.floor((this.props.data.micro_time  / 1000) % 60),
    		minutes: Math.floor((this.props.data.micro_time / 1000 / 60) % 60),
    		hours: Math.floor((this.props.data.micro_time / (1000 * 60 * 60)) % 24),
    		days: Math.floor(this.props.data.micro_time / (1000 * 60 * 60 * 24))
    	};
    	this.tick_seconds=this.tick_seconds.bind(this);
    }
   	componentDidMount() {
   		this.timerID_sec = setInterval(() => this.tick_seconds(),1000);
   	}
	componentWillUnmount() {
		clearInterval(this.timerID_sec);
	}
	tick_seconds() {
	    this.setState({
	      time: this.state.time - 1,
	      seconds: this.state.seconds - 1,
	    });

	    if(this.state.seconds === 0)
	    {
	    	this.setState({
	    		minutes: this.state.minutes - 1,
	    		seconds: 60,
	    	});
			if(this.state.minutes < 0)
	    	{
		    	this.setState({
		    		minutes: 59,
		    		hours: this.state.hours - 1,
		    	});
		    }
		    if(this.state.hours < 0)
		    {
		    		if(this.state.days > 0)
		    		{
						this.setState({
							days : this.state.days - 1,
						});
					}	
			}
	    }
	    
	}
	render(){
		var data = this.props.data;
		return(
			<div className="col-md-3 col-sm-6 "> 
				<div className="prdt_blk">
					<div>
						<Link className='cursor' to={data.type === "seed" ? "/web/sdetails/"+data.sname+"/"+data.id : "/web/pdetails/"+data.url_dtype_name+"/"+data.url_cat_name+"/"+data.url_brand_name+"/"+data.url_product_name+"/"+data.pid+"/"+data.id} >
							<div>
	                          {data.type ==="seed" ? <img className="itm_img" src={data.img !== null && data.img !=='' ? data.img : 'https://aquadeals.in/admin/assets/icons/web_icons/noImage.png'} alt="" height="112px" /> : <img className="itm_img" src={data.img !==null && data.img !=='' ? data.img : 'https://aquadeals.in/admin/assets/icons/web_icons/noImage.png'} alt="" height="112px" /> }
	                      	</div>
	                      	{data.title ? <p className="web_pro_item_title">{data.title}</p> : <p>&nbsp;</p>}
	                      	{data.brand !==null && data.brand !=="" ? <p className="web_pro_item_brnd">{data.brand}</p> :  <p>&nbsp;</p>}
	                      	{data.price ? <h4 className="pro_mrp">MRP ₹ {data.price}</h4> : <h4 className="pro_mrp">&nbsp;</h4>}
	                      	{data.deal_price ? <p className="web_pro_item_offer">Promotional Offer :  ₹ {data.deal_price} </p> : <p className="web_pro_item_offer">&nbsp;</p>}
	                        <div className="web_promo_clock">
                      		  {this.state.days > 0 ? <p><span className="promo_clk_num">{this.state.days}</span> <span className="promo_clk_txt1">{this.state.days === 0 ? 'Days' : this.state.days > 1 ? 'Days' : 'Day' }</span></p> : <p>&nbsp;</p>}
                      		  <p><span className="promo_clk_num promo_hrs">{this.state.hours <= 9 ? 0 : ''}{this.state.hours}</span><span className="promo_clk_txt"> hrs</span><span className="promo_clk_num"> {this.state.minutes <= 9 ? 0 : ''}{this.state.minutes}</span><span className="promo_clk_txt"> min</span><span className="promo_clk_num"> {this.state.seconds}</span><span className="promo_clk_txt"> sec</span></p>
                      	    </div>
                      </Link>	
	                </div>
				</div>
			</div>
				
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/Web_AllPromoOffers.js
 **/